/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FuelUpGameActionRequest
 */
export interface FuelUpGameActionRequest {
    /**
     * Game action to perform
     * @type {string}
     * @memberof FuelUpGameActionRequest
     */
    action: FuelUpGameActionRequestActionEnum;
    /**
     * Required confirmation for reset action
     * @type {boolean}
     * @memberof FuelUpGameActionRequest
     */
    confirmReset?: boolean;
}


/**
 * @export
 */
export const FuelUpGameActionRequestActionEnum = {
    start: 'start',
    pause: 'pause',
    resume: 'resume',
    reset: 'reset'
} as const;
export type FuelUpGameActionRequestActionEnum = typeof FuelUpGameActionRequestActionEnum[keyof typeof FuelUpGameActionRequestActionEnum];


/**
 * Check if a given object implements the FuelUpGameActionRequest interface.
 */
export function instanceOfFuelUpGameActionRequest(value: object): value is FuelUpGameActionRequest {
    if (!('action' in value) || value['action'] === undefined) return false;
    return true;
}

export function FuelUpGameActionRequestFromJSON(json: any): FuelUpGameActionRequest {
    return FuelUpGameActionRequestFromJSONTyped(json, false);
}

export function FuelUpGameActionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpGameActionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'action': json['action'],
        'confirmReset': json['confirmReset'] == null ? undefined : json['confirmReset'],
    };
}

export function FuelUpGameActionRequestToJSON(json: any): FuelUpGameActionRequest {
    return FuelUpGameActionRequestToJSONTyped(json, false);
}

export function FuelUpGameActionRequestToJSONTyped(value?: FuelUpGameActionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'action': value['action'],
        'confirmReset': value['confirmReset'],
    };
}

